<template>
  <div role="tabpanel" class="tab-pane" id="tabs-complaint">
    <div class="addInHiddenInView">
      <div
        v-if="checkCredential('complaintAdd') && !bookingIsDeleted"
        class="tabs_button"
      >
        <b>
          <a
            class="black_color upper"
            href="#"
            data-toggle="modal"
            data-target="#popupi"
            @click.prevent="showAddIssuePopup"
            >Add Issue &nbsp;<i class="fa fa-plus"></i
          ></a>
        </b>
      </div>
    </div>
    <div id="complaint-info" class="height-100">
      <div class="tab_padding float_none height-100">
        <div class="height-100" v-if="bookingComplaints.length">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th><b>Date</b></th>
                <th><b>Comment</b></th>
                <th><b>User</b></th>
                <th><b>Action</b></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="complaint in bookingComplaints"
                :key="complaint.complaint_id"
              >
                <td>{{ formatDate(complaint.created) }}</td>
                <td>
                  <a
                    v-if="checkCredential('complaintView')"
                    :href="`/issue/view/${complaint.complaint_id}`"
                    class="details_info_opt"
                    >{{ trimComment(complaint.comment) }}</a
                  >
                  <span v-else class="a_black">{{
                    trimComment(complaint.comment)
                  }}</span>
                </td>
                <td>{{ complaint.username }}</td>
                <td>
                  <a
                    href="#"
                    data-toggle="modal"
                    data-target="#popupi"
                    @click.prevent="showEditIssuePopup(complaint.complaint_id)"
                  >
                    <img src="/pic/icons/edit.png" title="Edit" alt="Edit" />
                  </a>
                  <a
                    :href="`#delete-issue-confirmation${complaint.complaint_id}`"
                    data-toggle="modal"
                  >
                    <img
                      src="/pic/icons/delete.png"
                      title="Delete"
                      alt="Delete"
                    />
                  </a>
                  <confirmation-popup
                    title="Warning"
                    message="are you sure you want to delete this issue?"
                    :id="`delete-issue-confirmation${complaint.complaint_id}`"
                    confirm-btn-text="Yes"
                    cancel-btn-text="No"
                    @on-confirm="confirmDelete(complaint.complaint_id)"
                  ></confirmation-popup>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="inquiry-no-result">
          <br />
          <h3 class="font-bold"><span class="fa fa-ban"></span> No complaints added</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSingleTabData } from "@/modules/Booking/api/BookingViewTabs";
import moment from "moment-timezone";
import ConfirmationPopup from "@/modules/common/components/ConfirmationPopup.vue";

export default {
  name: "IssuesTab",
  components: { ConfirmationPopup },
  props: {
    itemType: {
      type: String,
      required: true,
    },
    itemId: {
      type: Number,
      required: true,
    },
    credentials: {
      type: Object,
      default: () => ({}), // Default value is an empty object
    },
    view: "booking",
  },
  data() {
    return {
      bookingIsDeleted: false,
      bookingComplaints: [],
      dateTimeObj: null,
    };
  },
  methods: {
    checkCredential(permission) {
      if (this.credentials[permission]) {
        return true;
      } else {
        return false;
      }
    },
    formatDate(created) {
      const dateFormat = this.convertToMomentFormat(
        this.dateTimeObj?.date_format
      );
      return moment(created * 1000)
        .tz(this.dateTimeObj.time_zone)
        .format(dateFormat);
    },
    trimComment(comment) {
      return comment.length > 50 ? `${comment.substring(0, 50)}...` : comment;
    },
    showAddIssuePopup() {
      let AddPopUpUrl = `/complaint/add/${this.itemId}`;
      window.popupi("Add Issue", AddPopUpUrl);
    },
    showEditIssuePopup(complaintId) {
      let editPopUpUrl = `/complaint/edit/${complaintId}`;
      window.popupi("Edit Issue", editPopUpUrl);
    },
    confirmDelete(complaintId) {
      window.location.href = `/complaint/delete/${complaintId}`;
    },
    fetchData() {
      let params = {
        type: "complaint",
        booking_id: this.itemId,
        fromVuejs: true,
      };
      getSingleTabData(params).then((response) => {
        this.bookingComplaints = response.data.bookingComplaints;
        this.bookingId = response.data.bookingId;
        this.dateTimeObj = response.data.dateTimeObj;
      });
    },
    convertToMomentFormat(format) {
      const mapping = {
        "EEEE, d MMMM y": "dddd, D MMMM YYYY",
        "d MMMM y": "D MMMM YYYY",
        "d MMM y": "D MMM YYYY",
        "dd/mm/yyyy": "DD/MM/YYYY",
        // Add any additional mappings as needed
      };
      return mapping[format] || "Format not recognized";
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
<style scoped>
.height-100 {
  height: 100vw;
}
</style>
